import styles from './styles.css';

import { Icon } from 'components/Icon';
import { ContactUs, Dialog } from 'components/Modal';
import Plan from './components/Plan';
import TitleWithDesc from './components/TitleWithDesc';
import plans from './plans';

import cx from 'classnames';
import { Button } from 'components/Form';
import useUser from 'modules/user/hook/useUser';

const plansRange = ['small', 'medium', 'large', 'enterprise'];

export default ({
  onSelect,
  minimalPlan,
  hideModal,
  action,
  setAction,
  onDowngrade,
  onEnterprise,
  flat,
}: any) => {
  const { merchant } = useUser();

  const title = merchant?.plan
    ? 'Update Shopify plan'
    : 'Which plan is right for you?';
  return (
    (action === 'enterprise' && <ContactUs onSubmit={onEnterprise} />) ||
    (action === 'downgrade' && (
      <Dialog
        state={{
          title: 'Are you sure you want to downgrade?',
          description:
            'You will lose access to some of your current features and the data\nwill be lost (forever). This cannot be undone.',
          onSubmit: () => onDowngrade(),
          submitText: 'Downgrade',
        }}
        hideModal={() => setAction()}
      />
    )) || (
      <div className={(!flat && styles.root) || void 0}>
        {!flat && (
          <button className={styles.close} onClick={hideModal}>
            <Icon name="close" width={24} height={24} />
          </button>
        )}
        <div
          className={cx(styles.wrap, {
            [styles.paddingTop]: !merchant?.plan || !merchant?.planConfirmed,
          })}
        >
          <div className={styles.head}>
            <div className={styles['title-with-desc']}>
              <TitleWithDesc title={title} />
            </div>
            <div className={styles.plans}>
              {plans.data.map((data, i) => (
                <Plan
                  isUnavailable={minimalPlan === i}
                  key={data.type}
                  isCurrent={
                    data.type === merchant?.plan && merchant?.planConfirmed
                  }
                  {...data}
                  onSelect={onSelect}
                  className={styles.column}
                />
              ))}
            </div>
          </div>
          <div className={styles.footerAction}>
            <Button
              onClick={() =>
                window.open('https://findify.io/pricing', '_blank')
              }
            >
              Compare plans
            </Button>
          </div>
        </div>
      </div>
    )
  );
};
